/* Effets des pages secondaires du thème Whoosh, repris de la maquette :
   - blog : filtres par catégorie (PageBlog.tsx) ;
   - contact : réponses rapides dépliables, sujet prérempli, n° de commande selon le sujet,
     erreurs, confirmation d'envoi (ContactInteractif.tsx).
   Aucune dépendance : JavaScript natif. Initialisé une fois par élément racine. */
(function () {
  "use strict";

  /* Minuteries à nettoyer quand l'éditeur retire une section. */
  var minuteries = [];

  function liste(noeuds) {
    return Array.prototype.slice.call(noeuds);
  }

  /* ---------------------------------------------------------------------------------
     Blog : « Tout » + une pilule par catégorie. L'article le plus récent du filtre passe en
     grande carte, les autres en grille (la grille disparaît s'il n'y en a pas).
     --------------------------------------------------------------------------------- */
  function initBlog(filtres) {
    if (!filtres || filtres.getAttribute("data-wh-init")) return;
    filtres.setAttribute("data-wh-init", "1");

    var racine = filtres.parentNode;
    var encart = racine.querySelector(".wb-encart");
    var boutons = liste(filtres.querySelectorAll(".wb-filtre"));
    var cartes = liste(racine.querySelectorAll("a.wb-carte"));

    function categorie(carte) {
      var c = carte.querySelector(".wb-carte__categorie");
      return c ? c.textContent : "";
    }

    function afficher(filtre) {
      boutons.forEach(function (b, i) {
        var actif = (filtre === null && i === 0) || (filtre !== null && b.textContent === filtre);
        b.className = actif ? "wb-filtre is-actif" : "wb-filtre";
        b.setAttribute("aria-selected", actif ? "true" : "false");
      });

      var grille = racine.querySelector(".wb-grille");
      if (grille && grille.parentNode) grille.parentNode.removeChild(grille);
      cartes.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });

      var visibles = cartes.filter(function (c) {
        return filtre === null || categorie(c) === filtre;
      });
      var premier = visibles[0];
      var suite = visibles.slice(1);
      var avant = encart && encart.parentNode === racine ? encart : null;

      function regler(carte, grande) {
        carte.className = grande ? "wb-carte wb-carte--grande" : "wb-carte";
        var img = carte.querySelector("img");
        if (img) img.setAttribute("loading", grande ? "eager" : "lazy");
      }

      if (premier) {
        regler(premier, true);
        racine.insertBefore(premier, avant);
      }
      if (suite.length) {
        var g = document.createElement("div");
        g.className = "wb-grille";
        suite.forEach(function (c) {
          regler(c, false);
          g.appendChild(c);
        });
        racine.insertBefore(g, avant);
      }
    }

    boutons.forEach(function (b, i) {
      b.addEventListener("click", function () {
        afficher(i === 0 ? null : b.textContent);
      });
    });
  }

  /* ---------------------------------------------------------------------------------
     Contact
     --------------------------------------------------------------------------------- */
  var CHAMPS = {
    nom: "contact[name]",
    email: "contact[email]",
    sujet: "contact[Sujet]",
    message: "contact[body]",
  };
  var ORDRE = ["nom", "email", "sujet", "message"];

  function initContact(wc) {
    if (!wc || wc.getAttribute("data-wh-init")) return;
    wc.setAttribute("data-wh-init", "1");

    var form = wc.querySelector(".wc__form");
    if (!form) return;

    var conf = { sujetsCommande: [], erreurs: {} };
    try {
      conf = JSON.parse(form.querySelector("[data-wc-config]").textContent);
    } catch (e) {
      /* configuration absente : les contrôles de base restent actifs */
    }
    var modeleSucces = form.querySelector("template[data-wc-succes]");
    var modeleCommande = form.querySelector("template[data-wc-commande]");
    var rangees = null; /* champs retirés de la page pendant la confirmation */
    var envoi = false;

    function champ(cle) {
      return form.querySelector('[name="' + CHAMPS[cle] + '"]');
    }

    /* --- Réponses rapides : une seule ouverte à la fois ---------------------------- */
    var questions = liste(wc.querySelectorAll(".wc__q"));
    var ouvert = -1;

    function majAide() {
      questions.forEach(function (li, i) {
        var o = ouvert === i;
        li.className = o ? "wc__q is-ouvert" : "wc__q";
        li.querySelector(".wc__q-tete").setAttribute("aria-expanded", o ? "true" : "false");
        li.querySelector(".wc__q-corps").hidden = !o;
      });
    }

    /* --- Erreurs de champ ----------------------------------------------------------- */
    function poserErreur(cle, message) {
      var el = champ(cle);
      if (!el) return;
      var label = el.closest("label");
      label.classList.add("is-erreur");
      el.setAttribute("aria-invalid", "true");
      var em = label.querySelector(".wc__erreur");
      if (!em) {
        em = document.createElement("em");
        em.className = "wc__erreur";
        label.appendChild(em);
      }
      em.textContent = message;
    }

    function effacerErreur(cle) {
      var el = champ(cle);
      if (!el) return;
      var label = el.closest("label");
      label.classList.remove("is-erreur");
      el.setAttribute("aria-invalid", "false");
      var em = label.querySelector(".wc__erreur");
      if (em) em.parentNode.removeChild(em);
    }

    /* --- N° de commande : seulement pour une commande ou un retour ------------------ */
    function majCommande() {
      var select = champ("sujet");
      if (!select || !modeleCommande) return;
      var avec = conf.sujetsCommande.indexOf(select.value) !== -1;
      var ligne = select.closest(".wc__ligne");
      var present = ligne.querySelector('[name="contact[Commande]"]');
      if (avec && !present) {
        ligne.classList.remove("wc__ligne--seul");
        ligne.appendChild(modeleCommande.content.firstElementChild.cloneNode(true));
      } else if (!avec && present) {
        var label = present.closest("label");
        label.parentNode.removeChild(label);
        ligne.classList.add("wc__ligne--seul");
      }
    }

    function ecrire(sujet) {
      var select = champ("sujet");
      if (select) select.value = sujet;
      majCommande();
      effacerErreur("sujet");
      form.scrollIntoView({ behavior: "smooth", block: "start" });
      minuteries.push(
        window.setTimeout(function () {
          var t = form.querySelector("textarea");
          if (t) t.focus({ preventScroll: true });
        }, 500)
      );
    }

    questions.forEach(function (li, i) {
      li.querySelector(".wc__q-tete").addEventListener("click", function () {
        ouvert = ouvert === i ? -1 : i;
        majAide();
      });
      li.querySelector(".wc__q-action").addEventListener("click", function (e) {
        ecrire(e.currentTarget.getAttribute("data-sujet") || "");
      });
    });

    /* --- Effacement des erreurs à la saisie ------------------------------------------ */
    ORDRE.forEach(function (cle) {
      var el = champ(cle);
      if (!el) return;
      el.addEventListener(cle === "sujet" ? "change" : "input", function () {
        if (cle === "sujet") majCommande();
        effacerErreur(cle);
      });
    });

    /* --- Nom du fichier choisi -------------------------------------------------------- */
    var fichier = form.querySelector(".wc__fichier input");
    var boutonFichier = form.querySelector(".wc__fichier-bouton");
    var libelleFichier = boutonFichier ? boutonFichier.lastChild.textContent : "";
    if (fichier && boutonFichier) {
      fichier.addEventListener("change", function () {
        var f = fichier.files && fichier.files[0];
        boutonFichier.lastChild.textContent = f ? f.name : libelleFichier;
      });
    }

    /* --- Confirmation d'envoi --------------------------------------------------------- */
    function nouveau() {
      var bloc = form.querySelector(".wc__succes");
      if (!rangees) {
        /* confirmation affichée par le serveur : on recharge le formulaire vide */
        window.location.assign(window.location.pathname + "#contact_form");
        return;
      }
      form.insertBefore(rangees, bloc);
      bloc.parentNode.removeChild(bloc);
      rangees = null;
      form.reset();
      majCommande();
      if (boutonFichier) boutonFichier.lastChild.textContent = libelleFichier;
      ORDRE.forEach(effacerErreur);
    }

    function montrerSucces() {
      var tete = form.querySelector(".wc__form-tete");
      rangees = document.createDocumentFragment();
      var n = tete.nextSibling;
      while (n) {
        var suivant = n.nextSibling;
        var technique = n.nodeType === 1 && (n.tagName === "TEMPLATE" || n.tagName === "SCRIPT");
        if (technique) break;
        rangees.appendChild(n);
        n = suivant;
      }
      var bloc = modeleSucces.content.firstElementChild.cloneNode(true);
      form.insertBefore(bloc, n);
      bloc.querySelector("button").addEventListener("click", nouveau);
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    /* Réponse affichée par le serveur (envoi sans JavaScript, ou contrôle anti-spam) */
    var blocServeur = form.querySelector(".wc__succes");
    if (blocServeur) blocServeur.querySelector("button").addEventListener("click", nouveau);

    /* --- Envoi : mêmes contrôles que la maquette, puis vrai formulaire Shopify -------- */
    function natif() {
      envoi = false;
      HTMLFormElement.prototype.submit.call(form);
    }

    function envoyer() {
      var donnees = new FormData(form);
      donnees.delete("fichier");
      envoi = true;
      fetch(form.getAttribute("action"), { method: "POST", body: donnees, credentials: "same-origin" })
        .then(function (r) {
          if (r.ok && /[?&]contact_posted=true/.test(r.url)) {
            envoi = false;
            montrerSucces();
          } else {
            natif();
          }
        })
        .catch(natif);
    }

    form.addEventListener("submit", function (e) {
      if (!modeleSucces) return;
      e.preventDefault();
      if (envoi) return;
      var d = new FormData(form);
      var err = {};
      if (!String(d.get(CHAMPS.nom) || "").trim()) err.nom = conf.erreurs.nom;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(d.get(CHAMPS.email) || "").trim())) err.email = conf.erreurs.email;
      if (!d.get(CHAMPS.sujet)) err.sujet = conf.erreurs.sujet;
      if (!String(d.get(CHAMPS.message) || "").trim()) err.message = conf.erreurs.message;
      ORDRE.forEach(function (cle) {
        if (err[cle]) poserErreur(cle, err[cle]);
        else effacerErreur(cle);
      });
      var premier = ORDRE.filter(function (cle) {
        return err[cle];
      })[0];
      if (premier) {
        champ(premier).focus();
        return;
      }
      envoyer();
    });
  }

  /* --------------------------------------------------------------------------------- */
  function init(portee) {
    liste(portee.querySelectorAll(".wb-filtres")).forEach(initBlog);
    liste(portee.querySelectorAll(".wc")).forEach(initContact);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Éditeur de thèmes : section rechargée, section retirée. */
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
  document.addEventListener("shopify:section:unload", function () {
    minuteries.forEach(function (t) {
      window.clearTimeout(t);
    });
    minuteries = [];
  });
})();
